document.addEventListener("DOMContentLoaded", function () {
  // Function to toggle submenu visibility
  function toggleSubmenu(item, show) {
    if (show) {
      item.classList.add("menu-sublink-open");
    } else {
      item.classList.remove("menu-sublink-open");
    }
  }

  // Function to handle menu link clicks
  function handleMenuLinkClick(event) {
    event.preventDefault();
    window.location.href = event.target.getAttribute("href");
  }

  // Function to show or hide the mega menu
  // function toggleMegaMenu(megaMenu, show) {
  //   const overlay = document.querySelector(".menu_overlay");
  //   if (show) {
  //     megaMenu.setAttribute("open", true);
  //     document.body.classList.add("mega-menu-open");
  //     if (overlay) {
  //       overlay.classList.remove("hidden");
  //     }
  //   } else {
  //     megaMenu.removeAttribute("open");
  //     document.body.classList.remove("mega-menu-open");
  //     if (overlay) {
  //       overlay.classList.add("hidden");
  //     }
  //   }
  // }

  // Add event listeners for menu items
  document.querySelectorAll(".mega-menu__list li").forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      toggleSubmenu(item, true);
    });
    item.addEventListener("mouseleave", function () {
      toggleSubmenu(item, false);
    });
  });

  // Add event listeners for menu links
  document
    .querySelectorAll(".mega-menu__link, .menu_parent_link")
    .forEach(function (link) {
      link.addEventListener("click", handleMenuLinkClick);
    });

  // Add event listeners for each mega menu
  // document.querySelectorAll(".mega-menu").forEach(function (megaMenu) {
  //   megaMenu.addEventListener("mouseenter", function () {
  //     toggleMegaMenu(megaMenu, true);
  //   });
  //   megaMenu.addEventListener("mouseleave", function () {
  //     toggleMegaMenu(megaMenu, false);
  //   });

  //   // Prevent default click behavior on the mega menu
  //   megaMenu.addEventListener("click", function (event) {
  //     event.preventDefault();
  //   });
  // });

document.querySelectorAll(".mega-menu").forEach(function (megaMenu) {
    megaMenu.addEventListener("click", function (event) {
        const isOpen = megaMenu.hasAttribute("open");
        toggleMegaMenu(megaMenu, !isOpen);
        event.preventDefault();
    });
});

function toggleMegaMenu(megaMenu, show) {
    const overlay = document.querySelector(".menu_overlay");
    if (show) {
        megaMenu.setAttribute("open", true);
        megaMenu.classList.add("is-active"); // Add class for animation
        document.body.classList.add("mega-menu-open");
        if (overlay) {
            overlay.classList.remove("hidden");
        }
    } else {
        megaMenu.removeAttribute("open");
        megaMenu.classList.remove("is-active"); // Remove class for animation
        document.body.classList.remove("mega-menu-open");
        if (overlay) {
            overlay.classList.add("hidden");
        }
    }
}

  // Function to handle expert link clicks
  function handleExpertLinkClick(event) {
    event.preventDefault();
    const elementWithShadowRoot = document.querySelector(
      '[location-id="cFeT6J2nl4i0chn30Cnh"]'
    );
    if (elementWithShadowRoot) {
      const shadowRoot = elementWithShadowRoot.shadowRoot;
      if (shadowRoot) {
        const elementInsideShadow = shadowRoot.querySelector(
          "#lc_text-widget--btn"
        );
        if (elementInsideShadow) {
          elementInsideShadow.click();
        } else {
          console.error("Element inside shadow root not found.");
        }
      } else {
        console.error("Shadow root not found.");
      }
    } else {
      console.error("Element with specified location-id not found.");
    }
  }

  // Add event listeners for expert links
  const expertLinks = document.querySelectorAll(".expert_link_wrap a");
  expertLinks.forEach(function (link) {
    link.addEventListener("click", handleExpertLinkClick);
  });
});
